import INITIAL_STATE from "./initial-state";
import { TYPES } from "../actions/layout-behaviors-actions";

const layoutBehaviorsReducer = (state = INITIAL_STATE.layoutBehaviors, action) => {
  switch (action.type) {
    case TYPES.SET_LAYOUT_BEHAVIORS: {
      return {
        ...INITIAL_STATE.layoutBehaviors,
        ...action.layoutBehaviors,
      };
    }

    default:
      return state;
  }
};

export default layoutBehaviorsReducer;
